// ========== SCSS ==========
import '../scss/loader.scss';

export default function Loader() {
  return (
    <div className="loader-container">
      <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  );
}
